module.exports = __webpack_public_path__ + "assets/960e4e9e8ec7ba7a60e4336865f0cd6f.mp4";